import * as React from 'react';
import { getHeaderKey, getFooterKey } from './helpers.js';
import { BOOKENDS_META_TAG_NAME, REACT_COMP_VERSION } from '../constants.js';

var getHeaderComponentSlug = function (headerType) {
    return "".concat(headerType, "_header");
};
var getFooterComponentSlug = function (footerType) {
    return "".concat(footerType, "_footer");
};
var BookendsMetaTag = function (props) {
    var Comp = props.renderWith || React.Fragment;
    return React.createElement(Comp, null,
        React.createElement("meta", { name: BOOKENDS_META_TAG_NAME, "data-headercomponent": props.headerType ? getHeaderComponentSlug(props.headerType) : undefined, "data-footercomponent": props.footerType ? getFooterComponentSlug(props.footerType) : undefined, "data-headerkey": props.headerType ? getHeaderKey(props.tenant, props.locale, props.headerType, props.hideSearch, props.hideVat, props.showStickyHeader) : undefined, "data-footerkey": props.footerType ? getFooterKey(props.tenant, props.locale, props.footerType) : undefined, "data-inline-critical-css": props.inlineCriticalCss === true || false, "data-react-bookends-major-version": REACT_COMP_VERSION }));
};

export { BookendsMetaTag, getFooterComponentSlug, getHeaderComponentSlug };
//# sourceMappingURL=HeadTag.js.map
